export default "__VITE_ASSET__BA6Fo18Y__"